/* tslint:disable */
/* eslint-disable */
/**
 * Remaster API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ApiError } from './ApiError'
import { ApiErrorFromJSON, ApiErrorFromJSONTyped, ApiErrorToJSON } from './ApiError'
import type { OrderNumber } from './OrderNumber'
import { OrderNumberFromJSON, OrderNumberFromJSONTyped, OrderNumberToJSON } from './OrderNumber'

/**
 *
 * @export
 * @interface EnvelopedOrderNumberOrderCreatePublic
 */
export interface EnvelopedOrderNumberOrderCreatePublic {
  /**
   *
   * @type {OrderNumber}
   * @memberof EnvelopedOrderNumberOrderCreatePublic
   */
  body: OrderNumber
  /**
   *
   * @type {Array<ApiError>}
   * @memberof EnvelopedOrderNumberOrderCreatePublic
   */
  errors: Array<ApiError>
}

/**
 * Check if a given object implements the EnvelopedOrderNumberOrderCreatePublic interface.
 */
export function instanceOfEnvelopedOrderNumberOrderCreatePublic(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'body' in value
  isInstance = isInstance && 'errors' in value

  return isInstance
}

export function EnvelopedOrderNumberOrderCreatePublicFromJSON(
  json: any,
): EnvelopedOrderNumberOrderCreatePublic {
  return EnvelopedOrderNumberOrderCreatePublicFromJSONTyped(json, false)
}

export function EnvelopedOrderNumberOrderCreatePublicFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EnvelopedOrderNumberOrderCreatePublic {
  if (json === undefined || json === null) {
    return json
  }
  return {
    body: OrderNumberFromJSON(json['body']),
    errors: (json['errors'] as Array<any>).map(ApiErrorFromJSON),
  }
}

export function EnvelopedOrderNumberOrderCreatePublicToJSON(
  value?: EnvelopedOrderNumberOrderCreatePublic | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    body: OrderNumberToJSON(value.body),
    errors: (value.errors as Array<any>).map(ApiErrorToJSON),
  }
}
